import { render, staticRenderFns } from "./hpEvent.vue?vue&type=template&id=8870cb88&scoped=true&"
import script from "./hpEvent.vue?vue&type=script&lang=js&"
export * from "./hpEvent.vue?vue&type=script&lang=js&"
import style0 from "./hpEvent.vue?vue&type=style&index=0&id=8870cb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8870cb88",
  null
  
)

export default component.exports